import React, { Fragment } from 'react'
import SideNavigation from '../SideNavigation/SideNavigation'
import TopNavigation from '../TopNavigation/TopNavigation'
import { Outlet, useLocation } from 'react-router-dom'
import { useSelector } from "react-redux";
import { getUserRoleCodeFromStorage } from "../../../utils/utils";

function Main() {
  
  const location = useLocation();
  const userRoleCode = getUserRoleCodeFromStorage();
  const isAdminRole = userRoleCode === "ROLE_SUPER_ADMIN" || userRoleCode === "ROLE_ADMIN";
  const isScreensaverPath = location?.pathname === "/hms/ScreensaverConfiguration";

  let isPathTrue = (location?.pathname === "/hms/ConfigurationNewRoom" || location?.pathname === "/hms/WelcomeMessages" || location?.pathname === "/hms/RailConfiguration" ||
  location?.pathname === "/hms/HotelServiceConfiguration" || location?.pathname === "/hms/HeroBanner" || location?.pathname === "/hms/HotelChannels" || location?.pathname === "/hms/WelcomeScreenConfig" ||
  location?.pathname === "/hms/ConfigurationBackgroundImage" || location?.pathname === "/hms/GroupRooms" || 
  location?.pathname === "/hms/CustomizeWelcomeScreen" || location.pathname === "/hms/cityConfiguration" || location.pathname === "/hms/guestMessage")
  
  // Screensaver is allowed for Admin/Super Admin on third-party hotels; other roles stay masked
  const shouldMaskThirdPartyConfig = isPathTrue || (isScreensaverPath && !isAdminRole);

  const isPathTrueApkDashboard = location.pathname === "/hms/Dashboard/APK_Version_Dashboard"
  
  const { viewType } = useSelector((state) => state.viewTypeReducer);
  
  return (
    <Fragment>
      <TopNavigation />
      <SideNavigation />
      <div className={`render-content ${(viewType==='hotelApp' && shouldMaskThirdPartyConfig) || (viewType==='custom' && isPathTrueApkDashboard) ? 'page-mask':""}`}>
        {viewType==='hotelApp' && shouldMaskThirdPartyConfig && <div className='mask-content'>This hotel is on Third Party Hotel Apps. <br/>Please select different hotel to create/edit configurations.</div>}
        {viewType==='custom' && isPathTrueApkDashboard && <div className='mask-content'>This hotel is TP-HMS. <br/>Please select Third Party hotel to view details.</div>}
        <Outlet />
      </div>
    </Fragment>
  )
}

export default Main